export default (() => {  
  // Direct DOM access - bypassing any potential interference
  window.addEventListener('load', initScrollButton);
  document.addEventListener('DOMContentLoaded', initScrollButton);
  
  function initScrollButton() {
    // Find or create the button
    let scrollBtn = document.getElementById('scroll-to-top');
    
    if (!scrollBtn) {
      console.log("Scroll button not found in DOM, functionality disabled");
      return;
    }
    
    // Remove any existing event listeners (in case this runs multiple times)
    const newButton = scrollBtn.cloneNode(true);
    scrollBtn.parentNode.replaceChild(newButton, scrollBtn);
    scrollBtn = newButton;
    
    // Add a very direct click handler that can't be easily interfered with
    scrollBtn.onclick = function(e) {
      e.preventDefault();
      e.stopPropagation();
      console.log("Scroll button clicked - direct handler!");
      
      try {
        // Try all possible scroll methods
        window.scroll({top: 0, behavior: 'smooth'});
        window.scrollTo({top: 0, behavior: 'smooth'});
        document.documentElement.scrollTo({top: 0, behavior: 'smooth'});
        document.body.scrollTo({top: 0, behavior: 'smooth'});
        
        // Fallbacks for older browsers
        document.documentElement.scrollTop = 0;
        document.body.scrollTop = 0;
      } catch (error) {
        console.error("Error scrolling to top:", error);
        // Last resort - force a jump to top
        window.location.href = "#top";
      }
      
      return false; // Prevent any default behavior
    };
    
    // Ensure button is styled for clicking
    scrollBtn.style.cursor = 'pointer !important';
    
    // Monitor scroll position
    window.addEventListener('scroll', updateButtonVisibility);
    setInterval(updateButtonVisibility, 200); // Backup check
    
    // Initial check
    updateButtonVisibility();
  }
  
  function updateButtonVisibility() {
    const scrollY = window.pageYOffset || window.scrollY || document.documentElement.scrollTop || document.body.scrollTop || 0;
    const scrollBtn = document.getElementById('scroll-to-top');
    
    if (scrollBtn) {
      if (scrollY > 300) {
        scrollBtn.classList.add('visible');
      } else {
        scrollBtn.classList.remove('visible');
      }
    }
  }
})();
